module.exports = __webpack_public_path__ + "static/media/user.25ae7e73.svg";